import React from 'react';
import PropTypes from 'prop-types';
import { Decimal } from '~/modules/common/components';
import { OVERVIEW_UNITS_ENUM } from '~/modules/resource-management/common/enums';

const getUnitSuffix = overviewUnit => {
  if (!overviewUnit || overviewUnit === OVERVIEW_UNITS_ENUM.FTE) return '';

  return overviewUnit === OVERVIEW_UNITS_ENUM.HOURS ? ' h' : '%';
};

export const FormattedUnitValue = ({ field, record, column }) => {
  const value = record[field]?.value ?? record[field];
  const className = record[field]?.renderClassName || column?.renderClassName;
  const overviewUnit = record[field]?.overviewUnit || column?.overviewUnit;

  return (
    <Decimal
      className={className}
      value={value}
      suffix={getUnitSuffix(overviewUnit)}
      fixedDecimalScale={false}
      enableFixedFormatDecimalScale
    />
  );
};

FormattedUnitValue.propTypes = {
  field: PropTypes.string,
  record: PropTypes.object,
  column: PropTypes.shape({
    renderClassName: PropTypes.string,
    overviewUnit: PropTypes.oneOf([
      OVERVIEW_UNITS_ENUM.HOURS,
      OVERVIEW_UNITS_ENUM.PERCENTAGE,
      OVERVIEW_UNITS_ENUM.FTE
    ])
  })
};

export default FormattedUnitValue;
